import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, Package, ArrowRight, Loader2 } from 'lucide-react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CheckoutSuccess = () => {
  const [searchParams] = useSearchParams();
  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useLanguage();
  
  const orderId = searchParams.get('order_id') || searchParams.get('extOrderId');

  useEffect(() => {
    const checkStatus = async () => {
      if (orderId) {
        try {
          const response = await axios.get(`${API}/payu/order-status/${orderId}`);
          setOrderStatus(response.data);
        } catch (error) {
          console.error('Error checking order status:', error);
        }
      }
      setLoading(false);
    };

    checkStatus();
  }, [orderId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 size={40} className="animate-spin text-yellow-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-16" data-testid="checkout-success-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border border-zinc-800 bg-[#111111] p-8 md:p-12 text-center">
          <CheckCircle size={80} className="text-green-500 mx-auto mb-6" />
          
          <h1 className="font-heading text-3xl sm:text-4xl uppercase text-white mb-4">
            {t.checkout?.success || 'Dziękujemy za zamówienie!'}
          </h1>
          
          <p className="text-zinc-400 mb-6">
            {t.checkout?.successMessage || 'Twoje zamówienie zostało przyjęte i jest przetwarzane.'}
          </p>

          {orderId && (
            <div className="bg-[#050505] border border-zinc-800 p-4 mb-6">
              <p className="text-zinc-500 text-sm mb-1">{t.checkout?.orderNumber || 'Numer zamówienia'}:</p>
              <p className="font-mono text-yellow-400 text-lg">{orderId}</p>
              {orderStatus && (
                <p className="text-sm mt-2">
                  Status: <span className={`font-bold ${orderStatus.status === 'paid' ? 'text-green-500' : 'text-yellow-500'}`}>
                    {orderStatus.status === 'paid' ? (t.checkout?.paid || 'Opłacone') : (t.checkout?.pending || 'Oczekuje')}
                  </span>
                </p>
              )}
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/orders" 
              className="bg-zinc-800 text-white uppercase font-bold tracking-widest px-6 py-3 border border-zinc-700 hover:border-yellow-400 hover:text-yellow-400 transition-colors inline-flex items-center justify-center gap-2"
            >
              <Package size={18} />
              {t.checkout?.viewOrders || 'Moje zamówienia'}
            </Link>
            
            <Link 
              to="/shop" 
              className="bg-yellow-400 text-black uppercase font-bold tracking-widest px-6 py-3 border border-yellow-400 hover:bg-black hover:text-yellow-400 transition-colors inline-flex items-center justify-center gap-2"
            >
              {t.checkout?.continueShopping || 'Kontynuuj zakupy'}
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
